import { Type } from 'class-transformer';
import { DepotDTO } from '../../vehicles/model/depot.dto';
import { ValueField } from '../../settings/model/value-field';
import { Vehicle } from '../../vehicles/model/vehicle';
import { Carrier } from './carrier';
import { User } from './user';

export class Group {
    groupId?: number;
    name: string;
    priority: number;
    @Type(() => User)
    users?: User[];
    @Type(() => ValueField)
    fields?: ValueField[];
    @Type(() => Vehicle)
    vehicles?: Vehicle[];
    @Type(() => Carrier)
    carrier?: Carrier;
    @Type(() => DepotDTO)
    depot?: DepotDTO;
}
